import React, { useState, useEffect, useContext, useMemo } from "react";
import { serverHost, createEndpoints } from "variables/serverdata";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
} from "react-bootstrap";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { Input } from "reactstrap";
import HusariaHeader from "views/pages/components/HusariaHeader";

const TimeconditionAddEdit = ({ method }) => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const { id } = useParams();
  const [loading, setLoading] = useState();
  const [formData, setFormData] = useState({
    name: "",
    extension: "",
    action: "",
    alternate_destination: "",
    order: 300,
    domain_uuid: "",
    context: "",
    enabled: true,
    description: "",
  });

  const [settings, setSettings] = useState([
    {
      group_number: 500,
      destination: "",
      conditions: [{ condition: "", start: "", end: "" }],
    },
  ]);
  const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
  const site_uuid = currentSite?.domain_uuid || null;
  const [selectedPresets, setSelectedPresets] = useState([]);

  // Data lists
  const [extensionList, setExtensionList] = useState([]);
  const [bridgeList, setBridgeList] = useState([]);
  const [voicemailList, setVoicemailList] = useState([]);
  const [flowsList, setFlowsList] = useState([]);
  const [ivrList, setIVRList] = useState([]);
  const [timeConditionsList, setTCList] = useState([]);
  const [destinationsList, setDestList] = useState([]);
  const [ringGroupList, setRingGroup] = useState([]);
  const [domainList, setDomainList] = useState([]);

  // Condition options
  const conditionOptions = [
    { value: "", label: "" },
    { value: "year", label: "Year" },
    { value: "mon", label: "Month" },
    { value: "mday", label: "Day of Month" },
    { value: "wday", label: "Day of Week" },
    { value: "week", label: "Week of Year" },
    { value: "mweek", label: "Week of Month" },
    { value: "hour", label: "Hour of Day" },
    { value: "minute-of-day", label: "Time of Day" },
    { value: "date-time", label: "Date & Time" },
  ];

  // Holiday presets
  const holidayPresets = [
    { value: "new_years_day", label: "New Year's Day" },
    { value: "family_day", label: "Family Day (CA)" },
    { value: "presidents_day", label: "Presidents' Day (US)" },
    { value: "good_friday", label: "Good Friday" },
    { value: "easter_monday", label: "Easter Monday" },
    { value: "victoria_day", label: "Victoria Day (CA)" },
    { value: "memorial_day", label: "Memorial Day (US)" },
    { value: "canada_day", label: "Canada Day" },
    { value: "independence_day", label: "Independence Day (US)" },
    { value: "labour_day", label: "Labour Day" },
    { value: "thanksgiving_day_ca", label: "Thanksgiving (CA)" },
    { value: "thanksgiving_day_us", label: "Thanksgiving (US)" },
    { value: "remembrance_day", label: "Remembrance Day (CA)" },
    { value: "veterans_day", label: "Veterans Day (US)" },
    { value: "christmas_eve", label: "Christmas Eve" },
    { value: "christmas_day", label: "Christmas Day" },
    { value: "boxing_day", label: "Boxing Day" },
    { value: "new_years_eve", label: "New Year's Eve" },
    { value: "t-r_day", label: "T R Day" },
  ];
  const endpoints = useMemo(
    () =>
      createEndpoints({
        setExtensionList,
        setBridgeList,
        setVoicemailList,
        setFlowsList,
        setIVRList,
        setTCList,
        setDestList,
        setRingGroup,
        setDomainList,
        site_uuid,
      }),
    [],
  );

  useEffect(() => {
    const fetchDomain = async (e) => {
      try {
        const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
        const domain_uuid = currentSite?.domain_uuid || null;
        const response = await fetch(
          `${serverHost}/fetch_domain_name/${domain_uuid}`,
        );
        if (!response.ok) throw new Error(`Failed to fetch domain context`);
        const data = await response.json();
        setFormData((prev) => ({ ...prev, context: data.result }));
      } catch (err) {
        setError(err.message);
      }
    };

    const fetchData = async () => {
      for (const key in endpoints) {
        const { url, map, setter } = endpoints[key];
        try {
          const res = await fetch(url);
          if (!res.ok) continue;

          const data = await res.json();
          const mapped = data.results.map(map);
          console.log(key, mapped);

          setter(mapped);
        } catch (err) {
          console.error(`Failed to fetch ${key}:`, err);
        }
      }
    };

    const fetchTimeCondition = async () => {
      try {
        let res = await fetch(
          `${serverHost}/get_row?table=v_dialplans&pk=dialplan_uuid&id=${encodeURIComponent(
            id,
          )}`,
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Row not found" : "Failed to fetch row",
          );
        let data = await res.json();
        if (!data?.result) throw new Error("Row not found");
        const dp = data.result;
        setFormData({
          name: dp.dialplan_name,
          extension: dp.dialplan_number,
          action: "",
          alternate_destination: "",
          order: dp.dialplan_order,
          domain_uuid: window.location.hostname,
          context: dp.dialplan_context,
          enabled: dp.dialplan_enabled,
          description: dp.dialplan_description,
        });
        res = await fetch(
          `${serverHost}/fetch_tc_actions/${encodeURIComponent(id)}`,
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Actions not found" : "Failed to fetch row",
          );
        data = await res.json();
        if (!data?.conditions || !data?.presets)
          throw new Error("actions not found");
        const conds = data.conditions;
        const presets = data.presets;
        console.log("Conditions: ", conds);
        console.log("Presets", presets);
        console.log("Action", data.preset_action);
        setSettings(conds);
        console.log(presets);
        setSelectedPresets(presets);
        setFormData((prev) => ({
          ...prev,
          alternate_destination: data.preset_action,
        }));
      } catch (err) {
        console.log("Failed to fetch time Conditions ", err);
        setError("Failed to fetch Time Conditions: ", err);
      }
    };
    const loadData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchData(),
          id ? fetchTimeCondition() : fetchDomain(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  // Get value options based on condition type
  const getValueOptions = (condition) => {
    switch (condition) {
      case "year":
        const years = [];
        const currentYear = 2015;
        for (let i = currentYear; i <= currentYear + 30; i++) {
          years.push({ value: i.toString(), label: i.toString() });
        }
        return years;

      case "mon":
        return [
          { value: "1", label: "January" },
          { value: "2", label: "February" },
          { value: "3", label: "March" },
          { value: "4", label: "April" },
          { value: "5", label: "May" },
          { value: "6", label: "June" },
          { value: "7", label: "July" },
          { value: "8", label: "August" },
          { value: "9", label: "September" },
          { value: "10", label: "October" },
          { value: "11", label: "November" },
          { value: "12", label: "December" },
        ];

      case "mday":
        const days = [];
        for (let i = 1; i <= 31; i++) {
          days.push({ value: i.toString(), label: i.toString() });
        }
        return days;

      case "wday":
        return [
          { value: "1", label: "Sunday" },
          { value: "2", label: "Monday" },
          { value: "3", label: "Tuesday" },
          { value: "4", label: "Wednesday" },
          { value: "5", label: "Thursday" },
          { value: "6", label: "Friday" },
          { value: "7", label: "Saturday" },
        ];

      case "week":
        const weeks = [];
        for (let i = 1; i <= 53; i++) {
          weeks.push({ value: i.toString(), label: `Week ${i}` });
        }
        return weeks;

      case "mweek":
        return [
          { value: "1", label: "Week 1" },
          { value: "2", label: "Week 2" },
          { value: "3", label: "Week 3" },
          { value: "4", label: "Week 4" },
          { value: "5", label: "Week 5" },
        ];

      case "hour":
        const hours = [];
        for (let i = 0; i < 24; i++) {
          hours.push({
            value: i.toString(),
            label: `${i.toString().padStart(2, "0")}:00`,
          });
        }
        return hours;

      case "minute-of-day":
      case "date-time":
        return [];

      default:
        return [];
    }
  };

  const labelStyle = {
    fontWeight: 600,
    color: isDark ? "#e2e8f0" : "#1e3a5f",
    marginBottom: "0.5rem",
  };

  const inputStyle = {
    backgroundColor: isDark ? "#374151" : "#fff",
    color: isDark ? "#e2e8f0" : "#495057",
    borderColor: isDark ? "#4b5563" : "#ced4da",
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSettingChange = (settingIndex, conditionIndex, field, value) => {
    const newSettings = [...settings];
    newSettings[settingIndex].conditions[conditionIndex][field] = value;

    if (field === "condition") {
      newSettings[settingIndex].conditions[conditionIndex].start = "";
      newSettings[settingIndex].conditions[conditionIndex].end = "";
    }

    setSettings(newSettings);
  };

  const handleGroupNumberChange = (settingIndex, value) => {
    const newSettings = [...settings];
    newSettings[settingIndex].group_number = value;
    setSettings(newSettings);
  };

  const handleDestinationChange = (settingIndex, value) => {
    const newSettings = [...settings];
    newSettings[settingIndex].destination = value;
    setSettings(newSettings);
  };

  const addConditionToSetting = (settingIndex) => {
    const newSettings = [...settings];
    newSettings[settingIndex].conditions.push({
      condition: "",
      start: "",
      end: "",
    });
    setSettings(newSettings);
  };

  const removeConditionFromSetting = (settingIndex, conditionIndex) => {
    const newSettings = [...settings];
    if (newSettings[settingIndex].conditions.length > 1) {
      newSettings[settingIndex].conditions.splice(conditionIndex, 1);
      setSettings(newSettings);
    }
  };

  const addSetting = () => {
    const lastGroupNumber =
      settings.length > 0 ? settings[settings.length - 1].group_number : 500;
    setSettings([
      ...settings,
      {
        group_number: lastGroupNumber + 5,
        destination: "",
        conditions: [{ condition: "", start: "", end: "" }],
      },
    ]);
  };

  const removeSetting = (index) => {
    setSettings(settings.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const missing = [];
    try {
      if (!formData.name) {
        missing.push("Name");
      }
      if (!formData.extension) {
        missing.push("Extension");
      }
      if (
        selectedPresets.length > 0 &&
        !(formData.action || formData.alternate_destination)
      ) {
        missing.push("Action or Alt Destination");
      }

      if (missing.length > 0) {
        setError("Please fill in missing fields: " + missing.join(", "));
        return;
      }
      const site = JSON.parse(localStorage.getItem("selectedSite"));
      const payload = {
        data: {
          ...formData,
        },
        settings: settings,
        presets: selectedPresets,
        client_uuid: site.client_uuid,
        site_name: site.company_name,
        insert_uuid: JSON.parse(localStorage.getItem("user")).user_uuid,
      };
      let endpoint = "time_condition";
      if (method === "edit") {
        endpoint = "update_time_condition";
        payload.site_uuid = site.site_uuid;
      }
      const response = await fetch(
        `${serverHost}/${endpoint}/${site.site_uuid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        navigate("/admin/hucs/time-conditions");
      } else {
        const error = await response.json();
        console.error("Failed to create time condition:", error);
        setError("Failed to create time condition");
      }
    } catch (error) {
      console.error("Error creating time condition:", error);
      setError("Error creating time condition: " + error);
    }
  };

  const handleCancel = () => {
    navigate("/admin/hucs/time-conditions");
  };

  if (loading) {
    return (
      <>
        <HusariaHeader
          name="Edit Inbound Route"
          parentName="HUCS"
          padding="4.5rem"
        />
        <Container className="mt--6">
          <Card className="shadow-sm" style={{ marginTop: "-3rem" }}>
            <Card.Body className="p-4 text-center">
              <p>
                Loading Time Condition<span className="loading-dots"></span>
              </p>
            </Card.Body>
          </Card>
        </Container>
      </>
    );
  }

  return (
    <>
      <HusariaHeader
        name={`${method.toUpperCase()} Time Condition`}
        parentName="HUCS"
        padding="4.5rem"
      />
      <Container fluid className="mt--6">
        <Card className="shadow-sm" style={{ border: "none" }}>
          <Card.Header
            style={{
              backgroundColor: isDark ? "#1f2937" : "#e9ecef",
              color: isDark ? "#e2e8f0" : "#1e3a5f",
              borderBottom: "none",
              padding: "1rem 1.5rem",
            }}
          >
            <h5 className="mb-0" style={{ fontWeight: 600 }}>
              {method.toUpperCase()} TIME CONDITION
            </h5>
          </Card.Header>

          <Card.Body
            style={{
              backgroundColor: isDark ? "#1f2937" : "#fff",
              padding: "1.5rem",
            }}
          >
            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              {/* Basic Information */}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>
                      Name <span style={{ color: "#dc3545" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter time condition name"
                      required
                      style={inputStyle}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>
                      Extension <span style={{ color: "#dc3545" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="extension"
                      value={formData.extension}
                      onChange={handleChange}
                      placeholder="Enter extension number"
                      required
                      style={inputStyle}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Settings Section */}
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Form.Label style={{ ...labelStyle, marginBottom: 0 }}>
                    Settings
                  </Form.Label>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={addSetting}
                    style={{
                      borderColor: "#5469d4",
                      color: "#5469d4",
                    }}
                  >
                    + Add Setting
                  </Button>
                </div>

                {settings.map((setting, settingIndex) => (
                  <Card
                    key={settingIndex}
                    className="mb-2"
                    style={{
                      backgroundColor: isDark ? "#374151" : "#f8f9fa",
                      border: `1px solid ${isDark ? "#4b5563" : "#dee2e6"}`,
                    }}
                  >
                    <Card.Body className="p-3">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center gap-3">
                          <small
                            style={{
                              color: isDark ? "#9ca3af" : "#6c757d",
                              fontWeight: 600,
                            }}
                          >
                            Setting {settingIndex + 1}
                          </small>
                        </div>
                        <div className="d-flex gap-2">
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => addConditionToSetting(settingIndex)}
                            style={{
                              borderColor: "#28a745",
                              color: "#28a745",
                              fontSize: "0.75rem",
                            }}
                          >
                            + Add Condition
                          </Button>
                          {settings.length > 1 && (
                            <Button
                              variant="outline-warning"
                              size="sm"
                              className="text-danger"
                              onClick={() => removeSetting(settingIndex)}
                            >
                              Remove Setting
                            </Button>
                          )}
                        </div>
                      </div>

                      {/* Destination dropdown for this setting */}
                      <Row className="mb-3">
                        <Col md={3}>
                          <Form.Label
                            style={{ ...labelStyle, fontSize: "0.875rem" }}
                          >
                            Group Number:
                          </Form.Label>
                          <Form.Control
                            type="number"
                            size="sm"
                            value={setting.group_number}
                            onChange={(e) =>
                              handleGroupNumberChange(
                                settingIndex,
                                e.target.value,
                              )
                            }
                            style={{ ...inputStyle, width: "100px" }}
                          />
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label
                              style={{ ...labelStyle, fontSize: "0.875rem" }}
                            >
                              Destination
                            </Form.Label>
                            <Input
                              type="select"
                              size="sm"
                              value={setting.destination}
                              onChange={(e) =>
                                handleDestinationChange(
                                  settingIndex,
                                  e.target.value,
                                )
                              }
                              style={inputStyle}
                            >
                              <option value="">Select...</option>
                              <optgroup label="Bridges">
                                {bridgeList.map((br) => (
                                  <option
                                    key={br.bridge_uuid}
                                    value={`bridge:${br.destination}`}
                                  >
                                    {br.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="Call Flows">
                                {flowsList.map((cf) => (
                                  <option
                                    key={cf.name}
                                    value={`transfer:${cf.value}`}
                                  >
                                    {cf.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="Destinations">
                                {destinationsList.map((d) => (
                                  <option
                                    key={d.value}
                                    value={`transfer:${d.value}`}
                                  >
                                    {d.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="Extensions">
                                {extensionList.map((ext) => (
                                  <option
                                    key={ext.extension_uuid}
                                    value={`transfer:${ext.name} XML ${ext.accountcode}`}
                                  >
                                    {ext.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="IVR Menus">
                                {ivrList.map((ivr) => (
                                  <option
                                    key={ivr.name}
                                    value={`transfer:${ivr.transfer}`}
                                  >
                                    {ivr.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="Ring Groups">
                                {ringGroupList.map((rg) => (
                                  <option
                                    key={rg.value}
                                    value={`transfer:${rg.value}`}
                                  >
                                    {rg.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="Time Conditions">
                                {timeConditionsList.map((tc) => (
                                  <option
                                    key={tc.name}
                                    value={`transfer:${tc.value}`}
                                  >
                                    {tc.name}
                                  </option>
                                ))}
                              </optgroup>
                              <optgroup label="Voicemails">
                                {voicemailList.map((vm) => (
                                  <option
                                    key={vm.voicemail_uuid}
                                    value={`transfer:${vm.value}`}
                                  >
                                    {vm.voicemail_id}
                                  </option>
                                ))}
                              </optgroup>
                            </Input>
                          </Form.Group>
                        </Col>
                      </Row>

                      {setting.conditions.map((condition, conditionIndex) => (
                        <div key={conditionIndex}>
                          {conditionIndex > 0 && (
                            <hr
                              style={{
                                borderColor: isDark ? "#4b5563" : "#dee2e6",
                                margin: "0.75rem 0",
                              }}
                            />
                          )}
                          <Row className="align-items-end">
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label
                                  style={{
                                    ...labelStyle,
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  Condition
                                </Form.Label>
                                <Input
                                  type="select"
                                  size="sm"
                                  value={condition.condition}
                                  onChange={(e) =>
                                    handleSettingChange(
                                      settingIndex,
                                      conditionIndex,
                                      "condition",
                                      e.target.value,
                                    )
                                  }
                                  style={inputStyle}
                                >
                                  {conditionOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </Input>
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label
                                  style={{
                                    ...labelStyle,
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  Start
                                </Form.Label>
                                {condition.condition === "date-time" ? (
                                  <Form.Control
                                    type="datetime-local"
                                    size="sm"
                                    value={condition.start}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "start",
                                        e.target.value,
                                      )
                                    }
                                    style={inputStyle}
                                  />
                                ) : condition.condition === "minute-of-day" ? (
                                  <Form.Control
                                    type="time"
                                    size="sm"
                                    value={condition.start}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "start",
                                        e.target.value,
                                      )
                                    }
                                    style={inputStyle}
                                  />
                                ) : condition.condition &&
                                  getValueOptions(condition.condition).length >
                                    0 ? (
                                  <Input
                                    type="select"
                                    size="sm"
                                    value={condition.start}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "start",
                                        e.target.value,
                                      )
                                    }
                                    style={inputStyle}
                                  >
                                    <option value="">Select...</option>
                                    {getValueOptions(condition.condition).map(
                                      (opt) => (
                                        <option
                                          key={opt.value}
                                          value={opt.value}
                                        >
                                          {opt.label}
                                        </option>
                                      ),
                                    )}
                                  </Input>
                                ) : (
                                  <Form.Control
                                    type="text"
                                    size="sm"
                                    value={condition.start}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "start",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Start value"
                                    style={inputStyle}
                                  />
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label
                                  style={{
                                    ...labelStyle,
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  End
                                </Form.Label>
                                {condition.condition === "date-time" ? (
                                  <Form.Control
                                    type="datetime-local"
                                    size="sm"
                                    value={condition.end}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "end",
                                        e.target.value,
                                      )
                                    }
                                    style={inputStyle}
                                  />
                                ) : condition.condition === "minute-of-day" ? (
                                  <Form.Control
                                    type="time"
                                    size="sm"
                                    value={condition.end}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "end",
                                        e.target.value,
                                      )
                                    }
                                    style={inputStyle}
                                  />
                                ) : condition.condition &&
                                  getValueOptions(condition.condition).length >
                                    0 ? (
                                  <Input
                                    type="select"
                                    size="sm"
                                    value={condition.end}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "end",
                                        e.target.value,
                                      )
                                    }
                                    style={inputStyle}
                                  >
                                    <option value="">Select...</option>
                                    {getValueOptions(condition.condition).map(
                                      (opt) => (
                                        <option
                                          key={opt.value}
                                          value={opt.value}
                                        >
                                          {opt.label}
                                        </option>
                                      ),
                                    )}
                                  </Input>
                                ) : (
                                  <Form.Control
                                    type="text"
                                    size="sm"
                                    value={condition.end}
                                    onChange={(e) =>
                                      handleSettingChange(
                                        settingIndex,
                                        conditionIndex,
                                        "end",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="End value"
                                    style={inputStyle}
                                  />
                                )}
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className="d-flex justify-content-end">
                                {setting.conditions.length > 1 && (
                                  <Button
                                    variant="outline-warning"
                                    size="sm"
                                    className="text-danger"
                                    onClick={() =>
                                      removeConditionFromSetting(
                                        settingIndex,
                                        conditionIndex,
                                      )
                                    }
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    Remove Condition
                                  </Button>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </Card.Body>
                  </Card>
                ))}
              </div>

              {/* Presets */}
              <div className="mb-3">
                <Form.Label style={labelStyle}>Holiday Presets</Form.Label>
                <Card
                  style={{
                    backgroundColor: isDark ? "#374151" : "#f8f9fa",
                    border: `1px solid ${isDark ? "#4b5563" : "#dee2e6"}`,
                  }}
                >
                  <Card.Body className="p-3">
                    <Row>
                      {holidayPresets.map((preset) => (
                        <Col md={3} key={preset.value} className="mb-2">
                          <Form.Check
                            type="checkbox"
                            id={`preset-${preset.value}`}
                            label={preset.label}
                            checked={selectedPresets.includes(preset.value)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedPresets([
                                  ...selectedPresets,
                                  preset.value,
                                ]);
                              } else {
                                setSelectedPresets(
                                  selectedPresets.filter(
                                    (p) => p !== preset.value,
                                  ),
                                );
                              }
                            }}
                            style={{
                              color: isDark ? "#e2e8f0" : "#495057",
                              fontSize: "0.875rem",
                            }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Card.Body>
                </Card>
              </div>

              {/* Action and Alternate Destination */}
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>Action</Form.Label>
                    <Input
                      type="select"
                      name="action"
                      value={formData.action}
                      onChange={handleChange}
                      style={inputStyle}
                    >
                      <option value="">Select...</option>
                      <optgroup label="Bridges">
                        {bridgeList.map((br) => (
                          <option
                            key={br.bridge_uuid}
                            value={`bridge:${br.destination}`}
                          >
                            {br.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Call Flows">
                        {flowsList.map((cf) => (
                          <option key={cf.name} value={`transfer:${cf.value}`}>
                            {cf.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Destinations">
                        {destinationsList.map((d) => (
                          <option key={d.value} value={`transfer:${d.value}`}>
                            {d.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Extensions">
                        {extensionList.map((ext) => (
                          <option
                            key={ext.extension_uuid}
                            value={`transfer:${ext.name} XML ${ext.accountcode}`}
                          >
                            {ext.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="IVR Menus">
                        {ivrList.map((ivr) => (
                          <option
                            key={ivr.name}
                            value={`transfer:${ivr.transfer}`}
                          >
                            {ivr.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Ring Groups">
                        {ringGroupList.map((rg) => (
                          <option key={rg.value} value={`transfer:${rg.value}`}>
                            {rg.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Time Conditions">
                        {timeConditionsList.map((tc) => (
                          <option key={tc.name} value={`transfer:${tc.value}`}>
                            {tc.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Voicemails">
                        {voicemailList.map((vm) => (
                          <option
                            key={vm.voicemail_uuid}
                            value={`transfer:${vm.value}`}
                          >
                            {vm.voicemail_id}
                          </option>
                        ))}
                      </optgroup>
                    </Input>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>
                      Alternate Destination
                    </Form.Label>
                    <Input
                      type="select"
                      name="alternate_destination"
                      value={formData.alternate_destination}
                      onChange={handleChange}
                      style={inputStyle}
                    >
                      <option value="">Select...</option>
                      <optgroup label="Bridges">
                        {bridgeList.map((br) => (
                          <option
                            key={br.bridge_uuid}
                            value={`bridge:${br.destination}`}
                          >
                            {br.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Call Flows">
                        {flowsList.map((cf) => (
                          <option key={cf.name} value={`transfer:${cf.value}`}>
                            {cf.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Destinations">
                        {destinationsList.map((d) => (
                          <option key={d.value} value={`transfer:${d.value}`}>
                            {d.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Extensions">
                        {extensionList.map((ext) => (
                          <option
                            key={ext.extension_uuid}
                            value={`transfer:${ext.name} XML ${ext.accountcode}`}
                          >
                            {ext.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="IVR Menus">
                        {ivrList.map((ivr) => (
                          <option
                            key={ivr.name}
                            value={`transfer:${ivr.transfer}`}
                          >
                            {ivr.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Ring Groups">
                        {ringGroupList.map((rg) => (
                          <option key={rg.value} value={`transfer:${rg.value}`}>
                            {rg.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Voicemails">
                        {voicemailList.map((vm) => (
                          <option
                            key={vm.voicemail_uuid}
                            value={`transfer:${vm.value}`}
                          >
                            {vm.voicemail_id}
                          </option>
                        ))}
                      </optgroup>
                    </Input>
                  </Form.Group>
                </Col>
              </Row>

              {/* Order and Domain */}
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>Order</Form.Label>
                    <Form.Control
                      type="number"
                      name="order"
                      value={formData.order}
                      onChange={handleChange}
                      style={inputStyle}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>Context</Form.Label>
                    <Form.Control
                      type="text"
                      name="context"
                      value={formData.context}
                      onChange={handleChange}
                      placeholder="Enter context"
                      style={{
                        ...inputStyle,
                        backgroundColor: isDark ? "#000000ff" : "#beb6b6ff",
                        color: isDark ? "#e2e8f0" : "#495057",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Enabled and Description */}
              <Row className="mb-3">
                <Col md={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <span style={{ color: isDark ? "#e2e8f0" : "#495057" }}>
                      Enabled
                    </span>

                    <label className="custom-toggle mb-0">
                      <input
                        type="checkbox"
                        id="enabled"
                        name="enabled"
                        checked={formData.enabled}
                        onChange={handleChange}
                      />
                      <span
                        className="custom-toggle-slider rounded-circle"
                        data-label-off="Off"
                        data-label-on="On"
                      />
                    </label>
                  </div>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label style={labelStyle}>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Enter description"
                      style={inputStyle}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Action Buttons */}
              <div className="d-flex justify-content-between mt-4">
                <Button variant="danger" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button type="success" variant="success" onClick={handleSubmit}>
                  {method.toUpperCase()} Time Condition
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default TimeconditionAddEdit;
